import { Close } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import clsx from 'clsx';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var JoveDialogHeader = function JoveDialogHeader(props) {
  var children = props.children,
      title = props.title,
      className = props.className,
      close = props.close,
      hideCloseButton = props.hideCloseButton;
  /**
   * methods
   */

  var closeAction = function closeAction() {
    close === null || close === void 0 ? void 0 : close();
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('border-b-grey-10 flex w-full flex-row items-center justify-between border px-4 py-2', className),
    children: [/*#__PURE__*/_jsx("span", {
      className: "text-xl font-bold",
      children: /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-row items-center",
        children: [title, children]
      })
    }), !hideCloseButton && /*#__PURE__*/_jsx(IconButton, {
      onClick: closeAction,
      children: /*#__PURE__*/_jsx(Close, {})
    })]
  });
};

export default JoveDialogHeader;